import i18n from '@/i18n/i18n'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
	rtl: i18n.locale === 'ar',
	theme: {
		themes: {
			light: {
				primary: '#264154',
				secondary: '#cba673',
			},
		},
	},
})
